module.exports = __webpack_public_path__ + "img/Picture1.63582cea.png";